import _ from 'lodash'

interface IDateComparatorOptions<T> {
  /**
   * Key to compare in object tuple.
   */
  comparatorKey?: string
  /**
   *  Function that returns the key of each iterated item
   */
  comparatorKeyGetter?: (item: T) => string
  /**
   * Ordenation mode (Ascending or Descending)
   * @default asc
   */
  ordenation?: 'asc' | 'desc'
}

/**
 * Date comparator function
 * @param options Date comparation options
 * @returns HOF Comparator
 */
export function dateComparator<T>(options: IDateComparatorOptions<T>) {
  if (!options.comparatorKey && !options.comparatorKeyGetter)
    throw new Error('You must provide a way to comparate values.')
  return (a: T, b: T): number => {
    const ordenation = options.ordenation || 'asc'
    const isEqual = 0
    const isBehind = ordenation === 'asc' ? -1 : 1
    const isAhead = ordenation === 'asc' ? 1 : -1

    const finalComparatorKeyA = options.comparatorKeyGetter
      ? options.comparatorKeyGetter(a)
      : options.comparatorKey || ''
    const finalComparatorKeyB = options.comparatorKeyGetter
      ? options.comparatorKeyGetter(b)
      : options.comparatorKey || ''

    const aValue = _.get(a, finalComparatorKeyA)
    const bValue = _.get(b, finalComparatorKeyB)

    if (!aValue && !bValue) return isEqual
    if (!aValue) return isBehind
    if (!bValue) return isAhead

    let aValid = true
    let bValid = true

    let aDate: number = +new Date()
    try {
      aDate = +new Date(aValue)
    } catch {
      aValid = false
    }

    let bDate: number = +new Date()
    try {
      bDate = +new Date(bValue)
    } catch {
      bValid = false
    }

    if (!aValid && !bValid) return 0
    if (!aValid) return isBehind
    if (!bValid) return isAhead

    return ordenation === 'asc' ? aDate - bDate : bDate - aDate
  }
}
